var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-expand-transition', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showArea,
      expression: "showArea"
    }],
    staticClass: "rounded-0",
    attrs: {
      "elevation": "0",
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" 분야선택 "), _c('v-spacer'), _c('v-icon', {
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-card-text', [_c('v-row', _vm._l(_vm.areas_structured, function (parent) {
    return _c('v-col', {
      key: parent._id,
      attrs: {
        "cols": "6",
        "lg": ""
      }
    }, [_c('v-row', [_c('v-col', {
      staticClass: "text-h6"
    }, [_vm._v(_vm._s(parent.name))])], 1), _vm._l(parent.children, function (child, i) {
      return _c('v-row', {
        key: i
      }, [_c('v-col', [child.name !== _vm.etcAreaName ? [_c('v-checkbox', {
        staticClass: "my-0 py-0",
        attrs: {
          "value": child._id,
          "hide-details": "",
          "multiple": "",
          "dense": ""
        },
        on: {
          "change": _vm.input
        },
        scopedSlots: _vm._u([{
          key: "label",
          fn: function fn() {
            return [_vm._v(" " + _vm._s(child.name) + " "), _c('span', {
              staticClass: "ml-1",
              staticStyle: {
                "color": "red"
              }
            }, [_vm._v("(" + _vm._s(child._experts.length) + ")")])];
          },
          proxy: true
        }], null, true),
        model: {
          value: _vm.filter._areas,
          callback: function callback($$v) {
            _vm.$set(_vm.filter, "_areas", $$v);
          },
          expression: "filter._areas"
        }
      })] : [_c('filter-areas-manual', {
        attrs: {
          "children": child.children
        },
        on: {
          "input": _vm.input
        },
        model: {
          value: _vm.filter.areas_manual,
          callback: function callback($$v) {
            _vm.$set(_vm.filter, "areas_manual", $$v);
          },
          expression: "filter.areas_manual"
        }
      })]], 2)], 1);
    })], 2);
  }), 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }